import { createApp } from "vue/dist/vue.esm-bundler.js"
import Calendrier from '../components/Calendrier.vue';
import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const currentDate = this.el.dataset.currentDate

        this.vue = createApp({
            template: '<Calendrier :start-date="currentDate" />',
            components: {
                Calendrier
            },
            data() {
                return {
                    currentDate: currentDate
                }
            },
        }).mount(this.el)
    }

    destroy() {
        if(this.vue){
            //this.vue.unmount()
            delete this.vue
        }
    }
}
